import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

export interface PendingRevisionProduct {
  id: string;
  name: string;
  revision_started_at: string;
  deadline_at: string;
  deadline_hours: number;
  review_message?: string;
}

async function fetchPendingRevisions(): Promise<PendingRevisionProduct[]> {
  const response = await api.get<{ data: PendingRevisionProduct[] }>(
    '/v1/products/pending-revisions'
  );
  return response.data.data ?? [];
}

export function usePendingRevisions() {
  const { data: pendingRevisions = [], isLoading } = useQuery({
    queryKey: ['products', 'pending-revisions'],
    queryFn: fetchPendingRevisions,
    staleTime: 5 * 60 * 1000, // 5 minutos
    refetchInterval: 5 * 60 * 1000,
  });

  return { pendingRevisions, isLoading };
}
